<template>
  <div class="container">
    <div v-if="loading">
      <div id="loader">
        <font-awesome-icon icon="spinner" spin />
      </div>
    </div>

    <h4 class="cardD">Cita para firma</h4>

    <div>
      <b-form-group label="Link cita Calendly" label-for="input-link-cita">
        <b-input-group class="mt-3">
          <b-input-group-append>
            <b-button
              :variant="isTextCopied ? 'success' : 'secondary'"
              squared
              v-b-tooltip.hover
              title="Copiar"
              @click="copyLinkToClipboard"
            >
              <b-icon v-if="isTextCopied" icon="check"></b-icon>
              <b-icon v-else icon="clipboard"></b-icon>
            </b-button>
          </b-input-group-append>
          <b-form-input
            id="input-link-cita"
            type="url"
            v-model="cita.link_calendario"
            placeholder="Link Calendly"
            disabled
          ></b-form-input>
        </b-input-group>
      </b-form-group>
    </div>

    <div class="row mt-3">
      <div class="col-md-3">
        <b-form-group label="Fecha de la cita" label-for="input-cita-fecha-cita">
          <b-form-input id="input-cita-fecha-cita" type="date" v-model="cita.fecha_cita" disabled></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group label="Hora de la cita" label-for="input-cita-hora-cita">
          <b-form-input id="input-cita-hora-cita" type="time" v-model="cita.hora_cita" disabled></b-form-input>
        </b-form-group>
      </div>
    </div>
    <div class="row" v-if="user == 'Staff'">
      <div class="col-md-6">
        <b-form-group label="Modificaciones" label-for="input-cita-modificaciones">
          <b-form-textarea id="input-cita-modificaciones" v-model="cita.modificaciones" disabled></b-form-textarea>
        </b-form-group>
      </div>
    </div>
    <div class="row" v-if="user == 'Staff'">
      <div class="col-md-4">
        <b-form-group label="La firma se llevó a cabo" label-for="input-cita-firam-realizada">
          <b-form-checkbox id="input-cita-firam-realizada" v-model="cita.firma_realizada" disabled></b-form-checkbox>
        </b-form-group>
      </div>
    </div>
    <div class="row" v-if="user == 'Staff'">
      <div class="col-md-6">
        <b-form-group label="Observaciones" label-for="input-cita-observaciones">
          <b-form-textarea id="input-cita-observaciones" v-model="cita.observaciones" disabled></b-form-textarea>
        </b-form-group>
      </div>
    </div>

    <div class="mt-4">
      <div class="">
        <b-button class="btn-fill orange-btn bottom2" size="m" @click="guardarHandler()">Continuar</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { CitasApi } from "@/api";

export default {
  name: "TabCitaFirma",

  props: {
    constitutiva: { type: Object },
    user: {
      type: String,
      default: "Client"
    }
  },

  created() {
    this.fetchCita();
  },

  data: () => ({
    loading: false,
    isTextCopied: false,
    fecha_formatted: null,

    existingAppointment: false,

    cita: {
      id: null,
      creado: null,
      actualizado: null,
      activo: null,

      cat_servicio_id: null,
      proceso_id: null,

      link_calendario: null,
      fecha_cita: null,
      hora_cita: null,
      modificaciones: null,
      firma_realizada: null,
      observaciones: null,
    },
  }),

  methods: {
    async fetchCita() {
      try {
        this.loading = true;

        const { value } = await CitasApi.list({
          page: 0,
          registersPerPage: 0,
          cat_servicio_id: 1,
          proceso_id: this.constitutiva.id,
        });

        if (value.length !== 0) {
          const cita = value[0];

          this.cita.id = cita.id;
          this.cita.creado = cita.creado;
          this.cita.actualizado = cita.actualizado;
          this.cita.activo = cita.activo;

          this.cita.cat_servicio_id = 1;
          this.cita.proceso_id = cita.proceso_id;

          this.cita.link_calendario = cita.link_calendario;
          this.cita.fecha_cita = cita.fecha_cita;
          this.cita.hora_cita = cita.hora_cita;
          this.cita.modificaciones = cita.modificaciones;
          this.cita.firma_realizada = cita.firma_realizada;
          this.cita.observaciones = cita.observaciones;

          this.existingAppointment = true;
        } else {
          this.cita.cat_servicio_id = 1;
          this.cita.proceso_id = this.constitutiva.id;
          this.existingAppointment = false;
        }

        this.$toast.success("Información cargada.", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        return true;
      } catch (error) {
        console.log(error);
        this.$toast.error("Ocurrió un error al cargar la información.", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
        return false;
      } finally {
        this.loading = false;
      }
    },

    guardarHandler() {
      this.submitSaveConstitucion();
    },

    submitSaveConstitucion() {
      this.$emit("saveConstitucion");
    },

    copyLinkToClipboard() {
      if (!this.constitutiva.link_calendario) {
        return;
      }

      navigator.clipboard.writeText(this.constitutiva.link_calendario).then((this.isTextCopied = true));
    },
  },
};
</script>

<style scoped>
.fecha {
  margin-top: 60px !important;
}
</style>
